import { isBuildingEmpty } from "./index81.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType as getRgObjectsOfType$1 } from "@project-rouge/rg-three";
const pipeRemoveEmptyBuildings = ([parent]) => {
	const plots = getRgObjectsOfType$1(parent, RG_TYPE.Plot);
	for (const plot of plots) plot.children = plot.children.filter((c) => c.type !== RG_TYPE.Building || c.type === RG_TYPE.Building && !isBuildingEmpty(c));
	return [parent, void 0];
};
export { pipeRemoveEmptyBuildings };

//# sourceMappingURL=index178.js.map